import * as React from 'react'
import styled from 'styled-components'

import { Tag } from './Tag'

import * as S from '../styles'
import { BackgroundColor } from '../styles/tag'

export type UserLabelProps = {
  /** Avatar is mandatory, but it might be undefined on some rare occasions: https://github.com/ulule/ulule/pull/3959#discussion_r501925300 */
  avatar: string | undefined
  avatarSize: 'extra-small' | 'small' | 'medium' | 'large'
  className?: string
  href: string
  name: string
  tag?: Tag
} & React.AnchorHTMLAttributes<HTMLAnchorElement>

type Tag = {
  backgroundColor?: BackgroundColor
  label: string
}

function UserLabelComponent({
  avatar,
  avatarSize,
  className,
  href,
  name,
  tag,
  ...rest
}: UserLabelProps): React.ReactElement<UserLabelProps> {
  return (
    <S.userLabel.UserLabel href={href} className={className} {...rest}>
      <S.image.Avatar src={avatar} type={avatarSize} />
      <S.heading.XXXS>
        {name} {tag && <Tag backgroundColor={tag.backgroundColor}>{tag.label}</Tag>}
      </S.heading.XXXS>
    </S.userLabel.UserLabel>
  )
}

export const UserLabel = styled(UserLabelComponent)<UserLabelProps>``
UserLabel.displayName = 'UserLabel'
